import React from "react";
import Button from "../../Button";
import Notification from "../../Notification";
import { AddressPopupPropTypes } from "../types";
import PropTypes from "prop-types";

const ForcePickupNotification = ({ labels, dangerIcon }) => {
    return (
        <>
            <Notification
                type="danger"
                title={labels.warningTitle}
                icon={<img src={dangerIcon} alt="warning" />}
            >
                <p>{labels.warning}</p>
                <Button
                    href="https://pottsalat.de/warteliste/"
                    label={labels.notifyMe}
                    variant="secondary"
                    size="XS"
                />
            </Notification>
            <h6 className="address-popup__title">{labels.forcePickupTitle}</h6>
            <h5 className="address-popup__subtitle">{labels.pickStore}</h5>
        </>
    );
};

ForcePickupNotification.propTypes = {
    labels: AddressPopupPropTypes.labels,
    dangerIcon: PropTypes.string,
};

export default ForcePickupNotification;
